<div class="mb-3">
  <div>

    <h1 class="pb-2 border-bottom fw-light" i18n>Einkaufsdetails</h1>

    <div class="row">

      <div class="col-sm-6">

        <div class="row mb-1">
          <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Bestellnummer</label>
          <div class="col-sm-8">
            <label class="col-sm-4 col-form-label col-form-label-sm">{{order.orderNumber}}</label>
          </div>
        </div>
        <div class="row mb-1">
          <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Kundennummer</label>
          <div class="col-sm-8">
            <label class="col-sm-4 col-form-label col-form-label-sm">{{order.buyerCustomerNumber}}</label>
          </div>
        </div>

        <div class="row mb-1">
          <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Einkauf am</label>
          <div class="col-sm-8">
            <label class="col-sm-4 col-form-label col-form-label-sm">{{order.orderDateTime | date:
            'short'}}</label>
          </div>
        </div>

        <div class="row mb-1">
          <label class="col-sm-4 col-form-label col-form-label-sm" i18n>Einkauf am</label>
          <div class="col-sm-8">
            <label class="col-sm-4 col-form-label col-form-label-sm">{{order.orderDateTime | date:
            'short'}}</label>
          </div>

        </div>

      </div>

    </div>

    <kendo-pdf-export #pdf paperSize="A4" margin="2cm" [scale]='0.75'>
      <div class="table-responsive">
        <table class="table table-striped table-sm">
          <thead>
            <tr>
              <th i18n>Pos-Nr.</th>
              <th i18n>Artikel</th>
              <th i18n>VK</th>
              <th i18n>Status</th>
            </tr>
          </thead>
          <tbody>
            @for (orderPos of order.orderPositions; track orderPos) {
              <tr class="nav-row">
                <td>{{orderPos.positionNumber}}</td>
                <td>{{orderPos.skuName1}}</td>
                <td>{{orderPos.grossPrice | currency: orderPos.currency}}</td>
                <td>{{orderPos.status | orderPositionStatusDisplayName}}</td>
                @if (profile?.isActive) {
                  <td>
                    <div class="btn-group" role="group" i18n-aria-label aria-label="Zeilenaktionen">
                      @if (orderPos.status == OrderPositionStatusConstants.PositionStatusIdDefault && showCancelButton) {
                        <button class="btn btn-sm btn-outline-secondary"
                          type="button" (click)="onClaim(orderPos.id, order.id)" i18n>
                                        <fa-icon [icon]="faWindowClose"></fa-icon> Storno anfordern
                                    </button>
                      }
                    </div>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>

    </kendo-pdf-export>

    <button class="btn btn-secondary m-2" type="button" (click)="onBackClicked()" i18n>Zurück</button>

  </div>
</div>